import React from 'react'
import { Link } from 'react-router-dom'

import TimeAgo from 'react-timeago'

class Update2 extends React.Component{



render() {

  return(
    <div>
      <h1 className="introduction-header" >Enterprise Update 1.0 Beta</h1>
      <p className="introduction-p-italic">
      By Nathan Sellers <TimeAgo date="Sept 10, 2018" />
      </p>
        <p className="introduction-p"> A new dawn is<span className="orange"> rising</span>!</p>
        <p className="introduction-p"> Our team has been working hard and is getting ready to release the first set of Newforma Enterprise specific APIs.
          These will be specific to NPC only and unlike their Hybrid counterpart will be useful for an administrator to accomplish repetitive tasks with ease.
           You can now manage via APIs <span className="blue">Companies</span>, <span className="blue">Contacts</span>, <span className="blue">Office Locations</span>,
          <span className="blue"> Project Admin</span> and <span className="blue">Project Teams</span>. Where the hybrid endpoints focused on information from the apsect
          of the individual user the Enterprise is from a high admin level, for more information please see our <Link to="reference"> Enterprise API Reference</Link> inside the
          <Link to="/documentation"> Documentation</Link> page.

        </p>


        <p className="introduction-p"> We of course will not be stopping here, everyday our Developers are working hard to create more powerful API resources to give
          you access to the information you need. Please visit the Updates page frequently to keep up with the most recent releases.

        </p>

      </div> )
}
}
export default Update2;



/** WEBPACK FOOTER **
 ** ./src/pages/Updates/update2.js
 **/